var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VuexModule, Module, Mutation } from 'vuex-module-decorators';
var RouterStore = (function (_super) {
    __extends(RouterStore, _super);
    function RouterStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.routerValidity = { isValid: false };
        return _this;
    }
    RouterStore.prototype.setRouteValidity = function (routerValidity) {
        this.routerValidity = routerValidity;
    };
    __decorate([
        Mutation
    ], RouterStore.prototype, "setRouteValidity", null);
    RouterStore = __decorate([
        Module({ name: 'router' })
    ], RouterStore);
    return RouterStore;
}(VuexModule));
export default RouterStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/router/store/RouterStore.ts
// module id = J7rg
// module chunks = 10